import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const MultipleOperatorSelector = props => {
    const allOption = props.operators.reduce((result, operators) => {
        result.value.push(operators.id);
        return result;
    }, {value: [], label: 'All'});
    const options = props.operators.map(elem => (
        {value: elem.id, label: elem.name}
    ));
    options.unshift(allOption);
    const defaultValue = props.operators.reduce((values, elem) => {
        if (props.operatorIds.includes(elem.id)) {
            values.push({
                value: elem.id,
                label: elem.name
            });
        }
        return values;
    }, []);
    return (
        <Select
            name={props.name}
            closeMenuOnSelect={true}
            value={defaultValue ? defaultValue : []}
            isMulti
            options={options}
            onChange={data => {
                const result = data.map(type => type.value);
                props.onOperatorsItemChange(result);
            }}
            styles={{
                control: (styles, { data, isSelected }) => ({
                    ...styles,
                    color: '#3e5569',
                    backgroundColor: 'white',
                    borderColor: '#e9ecef'
                }),
                singleValue: (styles, { data }) => ({
                    ...styles,
                    color: '#3e5569'
                }),
            }}
        />
    )
};

MultipleOperatorSelector.propTypes = {
    name: PropTypes.string,
    operators: PropTypes.object,
    operatorIds: PropTypes.object,
    onOperatorsItemChange: PropTypes.func
};

export default MultipleOperatorSelector;


// WEBPACK FOOTER //
// ./src/components/Store/MultipleOperatorSelector.js